// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "comment",
                Decco.stringToJson(v.comment)
              ],
              [
                "order_id",
                Decco.intToJson(v.order_id)
              ],
              [
                "admin_name",
                Decco.stringToJson(v.admin_name)
              ],
              [
                "admin_id",
                Decco.intToJson(v.admin_id)
              ]
            ]);
}

export {
  t_encode ,
  
}
/* No side effect */
